// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.puzzleBoardRow {
  display: flex;
  flex: 1;
  flex-direction: row;
  container-type: size;
  justify-content: center;
  align-items: center;
}

.puzzleBoardSpace {
  position: relative;
  background-color: var(--palette-surface);
  border: 1.5px solid var(--palette-border-strong);
  border-radius: var(--r-tile);
  margin: 4px;
  padding: 0px;
  width: calc(100cqh - 8px);
  max-width: 200px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
}

.puzzleBoardSpaceLetterDiv {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.puzzleBoardSpaceLetter {
  font-family: var(--font-board);
  font-weight: 600;
  color: var(--palette-text);
  font-size: min(64px, 48cqh);
  line-height: 1;
  /* Trim the line box to the glyph's cap/baseline so flexbox centers the
     actual letter, not the asymmetric font asc/descent box. iOS WebKit
     otherwise drops the glyph slightly low. Ignored by browsers without
     text-box support, which fall back to the line-height:1 centering. */
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
  user-select: none;
  -webkit-user-select: none;
}

.puzzleBoardSpaceLetterHitTarget {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 70cqh;
  width: 70cqh;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  /* background-color: #ff000066; */
}

.atRest {
  font-weight: normal;
}

.included {
  background-color: var(--palette-secondary);
  border-color: var(--palette-secondary);
}
.included .puzzleBoardSpaceLetter {
  color: var(--palette-on-secondary);
}

.tail {
  background-color: var(--palette-primary);
  border-color: var(--palette-primary);
}
.tail .puzzleBoardSpaceLetter {
  color: var(--palette-on-primary);
}

.puzzleBoardInnerContainer {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  flex: 1;
  min-height: 0;
}

.puzzleRowsContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 500px;
}

.buttonsBelowPuzzleContainer {
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin: 16px 4px 4px;
}

.rotateButton {
  flex: 1;
  font-family: var(--font-ui);
  font-weight: 600;
  font-size: 1rem;
  border-radius: var(--r-btn);
  padding: 14px 16px;
  cursor: pointer;
  background: transparent;
  color: var(--palette-text);
  border: 1.5px solid var(--palette-border-strong);
}

.scoreWordButton {
  flex: 1;
  font-family: var(--font-ui);
  font-weight: 600;
  font-size: 1rem;
  border-radius: var(--r-btn);
  padding: 14px 16px;
  cursor: pointer;
  background: var(--palette-primary);
  color: var(--palette-on-primary);
  border: 0;
}
.scoreWordButton.disabled {
  opacity: 0.4;
  cursor: default;
}

.buttonText {
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/puzzleBoard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gDAAgD;EAChD,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd;;;wEAGsE;EACtE,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,gCAAgC;EAChC,SAAS;AACX;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".puzzleBoardRow {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  container-type: size;\n  justify-content: center;\n  align-items: center;\n}\n\n.puzzleBoardSpace {\n  position: relative;\n  background-color: var(--palette-surface);\n  border: 1.5px solid var(--palette-border-strong);\n  border-radius: var(--r-tile);\n  margin: 4px;\n  padding: 0px;\n  width: calc(100cqh - 8px);\n  max-width: 200px;\n  justify-content: center;\n  align-items: center;\n  aspect-ratio: 1;\n}\n\n.puzzleBoardSpaceLetterDiv {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.puzzleBoardSpaceLetter {\n  font-family: var(--font-board);\n  font-weight: 600;\n  color: var(--palette-text);\n  font-size: min(64px, 48cqh);\n  line-height: 1;\n  /* Trim the line box to the glyph's cap/baseline so flexbox centers the\n     actual letter, not the asymmetric font asc/descent box. iOS WebKit\n     otherwise drops the glyph slightly low. Ignored by browsers without\n     text-box support, which fall back to the line-height:1 centering. */\n  text-box-trim: trim-both;\n  text-box-edge: cap alphabetic;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.puzzleBoardSpaceLetterHitTarget {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 70cqh;\n  width: 70cqh;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  /* background-color: #ff000066; */\n}\n\n.atRest {\n  font-weight: normal;\n}\n\n.included {\n  background-color: var(--palette-secondary);\n  border-color: var(--palette-secondary);\n}\n.included .puzzleBoardSpaceLetter {\n  color: var(--palette-on-secondary);\n}\n\n.tail {\n  background-color: var(--palette-primary);\n  border-color: var(--palette-primary);\n}\n.tail .puzzleBoardSpaceLetter {\n  color: var(--palette-on-primary);\n}\n\n.puzzleBoardInnerContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  flex: 1;\n  min-height: 0;\n}\n\n.puzzleRowsContainer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  max-height: 500px;\n}\n\n.buttonsBelowPuzzleContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  margin: 16px 4px 4px;\n}\n\n.rotateButton {\n  flex: 1;\n  font-family: var(--font-ui);\n  font-weight: 600;\n  font-size: 1rem;\n  border-radius: var(--r-btn);\n  padding: 14px 16px;\n  cursor: pointer;\n  background: transparent;\n  color: var(--palette-text);\n  border: 1.5px solid var(--palette-border-strong);\n}\n\n.scoreWordButton {\n  flex: 1;\n  font-family: var(--font-ui);\n  font-weight: 600;\n  font-size: 1rem;\n  border-radius: var(--r-btn);\n  padding: 14px 16px;\n  cursor: pointer;\n  background: var(--palette-primary);\n  color: var(--palette-on-primary);\n  border: 0;\n}\n.scoreWordButton.disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.buttonText {\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
